<template>
  <div class="contentChain">
    <div class="title">内容上链</div>
    <div class="tabContent">
      <div
        v-for="(item, index) in navList"
        :key="index"
        :class="[
          item.isOk ? 'navActiveColor' : '',
          item.type == navType ? 'navActiveBg' : '',
        ]"
      >
        <img src="@/assets/images/radioIconActive.png" v-if="item.isOk" />
        {{ item.name }}
      </div>
    </div>
    <chooseType v-if="navType == 1" @chooseType="chooseType" @isOk="isOk" />
    <workInformation
      v-if="navType == 2"
      @isOk="isOk"
      :publicData="publicData"
    />
    <workOwnershipInformation
      v-if="navType == 3"
      @isOk="isOk"
      :publicData="publicData"
    />
    <confirmInformation
      v-if="navType == 4"
      @isOk="isOk"
      :publicData="publicData"
    />
    <payment v-if="navType == 5" @isOk="isOk" />
    <submitApplication v-if="navType == 6" @isOk="isOk" />
    <div class="btnwap">
      <div class="btnContent">
        <div
          v-if="navType == 2 || navType == 3 || navType == 4"
          @click="navType = navType - 1"
        >
          上一步
        </div>
        <div
          v-if="navType == 2 || navType == 3 || navType == 4"
          @click="nextStep()"
        >
          <!-- {{ navType == 4 ? "提交" : "下一步" }} -->
          下一步
        </div>
        <!-- <div v-if="navType == 5" @click="$router.push('/')">返回到首页</div> -->
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import chooseType from "@/components/contentChain/chooseType";
import workInformation from "@/components/contentChain/workInformation";
import workOwnershipInformation from "@/components/contentChain/workOwnershipInformation";
import confirmInformation from "@/components/contentChain/confirmInformation";
import payment from "@/components/contentChain/payment";
import submitApplication from "@/components/contentChain/submitApplication";
// import { ElLoading } from "element-plus";

export default {
  name: "contentChain",
  data() {
    return {
      userInformation: JSON.parse(Cookies.get("userInformation")),
      publicData: {},
      num: 0,
      navType: 1,
      navList: [
        {
          name: "1.确权证书",
          type: 1,
          isOk: false,
        },
        {
          name: "2.作品信息",
          type: 2,
          isOk: false,
        },
        {
          name: "3.作品权属信息",
          type: 3,
          isOk: false,
        },
        {
          name: "4.确认消息",
          type: 4,
          isOk: false,
        },
        {
          name: "5.确认付款",
          type: 5,
          isOk: false,
        },
        {
          name: "6.提交申请",
          type: 6,
          isOk: false,
        },
      ],
    };
  },
  mounted() {
    if (this.$route.query.type == 1) {
      this.navList[0].isOk = true;
      this.navType = 2;
    }
  },
  methods: {
    nextStep() {
      // if(this.navList[this.navType-1].isOk == true){
      //   this.navType = this.navType+1
      // }else{
      this.publicData.personalType = this.num++;
      // }
    },
    isOk(e) {
      window.scrollTo(0, 0);
      let { key, isOk, payStatus } = e;
      if (
        (key == 2 && payStatus == 1) ||
        (key == 3 && payStatus == 1) ||
        (key == 4 && payStatus == 1)
      ) {
        this.navList[4].isOk = isOk;
        this.navType = this.navType + 2;
      } else if (key == 2 || key == 3 || key == 4 || key == 5) {
        this.navList[key - 1].isOk = isOk;
        this.navType = this.navType + 1;
      } else {
        this.navList[0].isOk = isOk;
      }
    },
    chooseType(e) {
      if (e == 1) {
        e = 2;
      }
      this.navType = e;
    },
    // navClick(item) {
    //   this.navType = item.type;
    // },
  },
  components: {
    chooseType,
    workInformation,
    workOwnershipInformation,
    confirmInformation,
    payment,
    submitApplication,
  },
};
</script>
<style lang="scss" scoped>
.contentChain {
  display: flex;
  flex-direction: column;
  align-items: center;
  .btnwap {
    width: 100%;
    display: flex;
    justify-content: center;
    position: sticky;
    bottom: 0;
    background: #fff;
    padding: 40px 0;
    z-index: 100;
    .btnContent {
      width: 432px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      div {
        text-align: center;
        border-radius: 8px;
        height: 40px;
        font-size: 14px;
        font-family: AlibabaPuHuiTiM;
        line-height: 40px;
        cursor: pointer;
      }
      div:nth-of-type(1) {
        width: 120px;
        color: #909399;
        text-align: center;
        background: #fff;
        border: 1px solid #c0c4cc;
        a {
          color: #909399 !important;
          display: block;
          width: 100%;
          height: 100%;
        }
      }
      div:nth-of-type(2) {
        width: 240px;
        color: #ffffff;
        background: #008aea;
      }
    }
  }
  .title {
    margin: 80px 0 40px 0;
    width: 100%;
    text-align: center;
    font-size: 30px;
    font-family: AlibabaPuHuiTiB;
    color: #303133;
  }
  .tabContent {
    width: 100%;
    height: 48px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #f5f7fa;
    box-shadow: 0px 0px 0px 0px #e6e6e6;
    margin-bottom: 56px;
    div {
      width: 160px;
      height: 48px;
      font-size: 14px;
      font-family: AlibabaPuHuiTiM;
      color: #909399;
      line-height: 48px;
      text-align: center;
      font-weight: 700;
      // cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 24px;
      }
    }
    .navActiveColor {
      color: #008aea;
    }
    .navActiveBg {
      background: #fff;
    }
  }
}
</style>
